export default __webpack_public_path__ + "static/media/Sudha@2x.e11607a1.png";